import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const MEMBER_TRANSACTION_API_URL = `${API_HOST}/api/memberTransaction`;

function* createMemberTransaction() {
  yield takeEvery(actions.CREATE_MEMBER_TRANSACTION, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], MEMBER_TRANSACTION_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error, 'memberTransaction', 'createMemberTransaction');
    } finally {
      yield put({ type: actions.CREATE_MEMBER_TRANSACTION_ENDED });
    }
  });
}

function* searchMemberTransactions() {
  yield takeEvery(actions.SEARCH_MEMBER_TRANSACTIONS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${MEMBER_TRANSACTION_API_URL}?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_TRANSACTIONS_ENDED });
    }
  });
}

function* findMemberTransaction() {
  yield takeEvery(actions.FIND_MEMBER_TRANSACTION, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${MEMBER_TRANSACTION_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.FIND_MEMBER_TRANSACTION_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberTransaction),
    fork(searchMemberTransactions),
    fork(findMemberTransaction),
  ]);
}
